import React, { useEffect, useCallback, useState } from 'react';
import { useLocation, history } from 'umi';
import qs from 'qs';
import { useDispatch } from 'dva';
import { Box, Button } from '@material-ui/core';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import request from '@/utils/request';
import ModalML from '@/components/ModalML/NewModalML';
import {
  TextFieldCom,
  SelectFieldCom,
  CheckBoxFieldCom,
} from '@/components/FormType';
import ResultList from './components/result_list/ResultList';
import SearchGroup from './components/search_group/SearchGroup';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { control, getValues, setValue, errors, handleSubmit, watch } =
    useForm();
  const [tableData, setTableData] = useState({ data: [], total: 0 });
  const { query, pathname } = location;
  // 结构到所有查询条件，包括分页条件
  const { empName, pageNum = '1', pageSize = '10', refreshTime } = query;
  const [listLoading, setListLoading] = useState(true);
  const [dialogStatus, setDialogStatus] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [depList, setDepList] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [rowInfo, setRowInfo] = useState(null);

  useEffect(() => {
    request('/coupon/dep/query/page', {
      method: 'POST',
      data: {
        pageNum: 1,
        pageSize: 10000,
      },
    })
      .then((res) => {
        const newDepList = res?.data?.data?.map((item) => ({
          ...item,
          id: String(item.id),
        }));
        setDepList(newDepList || []);
      })
      .catch(() => {});
  }, []);
  // 查询事件处理
  const handleSearch = (newParam) => {
    console.log('newParam', newParam);
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
        refreshTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
        refreshTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      })}`,
    );
  };
  //获取列表
  const fetchEmpList = useCallback(() => {
    setListLoading(true);
    const values = {
      pageNum,
      pageSize,
      empName: empName || null,
    };

    request('/coupon/emp/query/page', {
      method: 'POST',
      data: values,
    })
      .then((res) => {
        setTableData(res.data);
        setListLoading(false);
      })
      .catch(() => {
        setListLoading(false);
      });
  }, [dispatch, pageNum, pageSize, empName, refreshTime]);
  useEffect(() => {
    fetchEmpList();
  }, [fetchEmpList]);

  const handleCancel = () => {
    setDialogStatus(false);
  };

  const handleClickRow = (data, opt) => {
    setDisabled(opt);
    setRowInfo(data);
    console.log('data', data);
    setDialogStatus(true);

    if (data?.id) {
      request('/coupon/emp/query/one', {
        method: 'POST',
        data: {
          id: data.id,
        },
      }).then((res) => {
        const list =
          res.data
            ?.filter((item) => item.hasDep)
            ?.map((item) => String(item.id)) || [];
        setValue('employeeName', data.empName);
        setValue('employeePhone', data.phone);
        setValue('status', data.status);
        setValue('department', list);
        setValue('id', data?.id || '');
      });
    }
  };

  const handleSave = (data) => {
    const { employeeName, employeePhone, status, department, id } = data;
    console.log('id', id);
    const path = id ? '/coupon/emp/update' : '/coupon/emp/add';
    request(path, {
      method: 'POST',
      data: {
        empName: employeeName,
        phone: employeePhone,
        status,
        depIds: department || null,
        id,
      },
    }).then((res) => {
      if (res.code === 0) {
        window.message.toast({
          type: 'success',
          message: id ? '更新成功' : '新建成功',
          title: '成功',
        });
        setDialogStatus(false);
        history.replace(
          `${pathname}?${qs.stringify({
            ...query,
            pageSize: 10,
            pageNum: 1,
            refreshTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          })}`,
        );
      }
    });
  };

  const handleClickDelete = (data) => {
    request('/coupon/emp/delete', {
      method: 'POST',
      data: {
        id: data.id,
      },
    }).then((res) => {
      if (res.code === 0) {
        window.message.toast({
          type: 'success',
          message: '删除成功',
          title: '成功',
        });
        setOpenDialog(false);
        fetchEmpList();
      }
    });
  };
  return (
    <Box>
      <SearchGroup
        handleRestClick={handleRestClick}
        handleSearch={handleSearch}
        query={query}
      />
      <ResultList
        handlePageChange={handlePageChange}
        pageData={{ pageNum, pageSize }}
        tableData={tableData}
        listLoading={listLoading}
        handleClickRow={handleClickRow}
        handleClickDelete={handleClickDelete}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
      />
      <ModalML
        open={dialogStatus}
        setOpen={setDialogStatus}
        onCancel={handleCancel}
        title={
          disabled === 'detail'
            ? '详情'
            : disabled === 'add'
            ? '新建员工'
            : '编辑员工'
        }
        onClose={handleCancel}
      >
        <form onSubmit={handleSubmit(handleSave)}>
          <div
            style={{
              display: 'flex',
              gap: '24px',
              width: '600px',
              padding: '24px 24px 48px 24px',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '32px',
                flexDirection: 'column',
                flex: 1,
              }}
            >
              <TextFieldCom
                control={control}
                label="姓名"
                name="employeeName"
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                disabled={disabled === 'detail' || rowInfo?.hasBiding}
                rules={{ required: true, maxLength: 15 }}
              />
              <TextFieldCom
                control={control}
                label="手机号"
                name="employeePhone"
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                disabled={disabled === 'detail' || rowInfo?.hasBiding}
                isValidate="请输入正确的手机号"
                rules={{ required: true, pattern: /^1[3-9]\d{9}$/ }}
              />
              <SelectFieldCom
                control={control}
                setValue={setValue}
                getValues={getValues}
                name="status"
                label="状态"
                errors={errors}
                disabled={disabled === 'detail'}
                rules={{
                  required: true,
                }}
                watchAllFields={watch()}
                showLabel={false}
                typeList={[
                  {
                    name: '可用',
                    value: 'ENABLE',
                  },
                  {
                    name: '冻结',
                    value: 'FREEZE',
                  },
                ]}
              />

              <TextFieldCom
                style={{ display: 'none' }}
                control={control}
                name="id"
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                disabled={disabled === 'detail'}
              />
            </div>
            <div
              style={{
                border: '1px solid #E0E0E0',
                padding: '10px',
                borderRadius: '10px',
                flex: 1,
                minHeight: '188px',
              }}
            >
              <div
                style={{ fontSize: '14px', fontWeight: 'bold', color: '#000' }}
              >
                核销部门
              </div>
              <div style={{ maxHeight: '420px', overflow: 'auto' }}>
                <CheckBoxFieldCom
                  control={control}
                  name="department"
                  disabled={disabled === 'detail'}
                  setValue={setValue}
                  getValues={getValues}
                  checkedBoxList={depList}
                  fieldNames={{
                    label: 'depName',
                    value: 'id',
                  }}
                />
              </div>
            </div>
          </div>
          <Box
            className="button-group"
            sx={{
              display: 'flex',
              gap: '6px',
              justifyContent: 'flex-end',
              padding: '0 24px 24px 24px',
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleCancel}
            >
              返回
            </Button>

            {disabled !== 'detail' && (
              <Button variant="contained" type="submit">
                确定
              </Button>
            )}
          </Box>
        </form>
      </ModalML>
    </Box>
  );
};
